// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"89d1f5b2","393":"5a33b58e","399":"99fec483","453":"164137df","718":"1f8f3ee3","899":"684d1798","981":"e68e596f"}[chunkId] + ".chunk.js";
};